export default __webpack_public_path__ + "static/media/huakong.a9a9b68d.png";